/* this file is transformed by vux-loader */
/* eslint-disable */
export var loading = function loading(state) {
  return !!state.loading;
};
export var invalidResponse = function invalidResponse(state) {
  return state.invalidResponse;
};